<account-back>{{'Stock Level' | translate}}</account-back>

<div class="_account-section-grid w-10 w-12-m w-12-s">
    @for (item of content?.items; track $index; let i = $index) {
    @if(shouldShowContentItem(item)){
    <section2 [sectionTitle]="item.title"
              class="block height-100">
        <p class="p1 col-11"
           *iCms="'description' of item; content: 'html'; skipEmpty: true"></p>
        @if (item.links?.length) {
        @for (link of item.links; track $index) {
        <href [link]="link.url"
              class="block m-t-6">
            <button class="button-inline-2"><span *iCms="'linkText' of link;"></span></button>
        </href>
        }
        }
        @if (item.displayButtton) {
        @if(!isAccountRestricted){
        <a class="button m-t-7"
           [attr.href]="mediaFeedUrl">
            {{'Download stock level report' | translate}}
        </a>
        }
        @if(isAccountRestricted){
        <action class="button m-t-7"
                [status]="stockLevelReportStatus"
                (click)="downloadStockLevelReportCall()">
            {{'Download stock level report' | translate}}
        </action>
        <result class="block"
                [status]="stockLevelReportStatus"></result>
        <p class="p3 col-11 m-t"
           *iCms="'restrictedAccountButtonText' of item; skipEmpty: true"></p>
        }
        }
    </section2>
    }
    }
</div>
